import { render, staticRenderFns } from "./RequestInquiry.vue?vue&type=template&id=51ce96c8&scoped=true"
import script from "./RequestInquiry.vue?vue&type=script&lang=js"
export * from "./RequestInquiry.vue?vue&type=script&lang=js"
import style0 from "./RequestInquiry.vue?vue&type=style&index=0&id=51ce96c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ce96c8",
  null
  
)

export default component.exports